/*
 * Copyright (c) RECREWT GmbH 2022.
 */

import { Pipe, PipeTransform } from '@angular/core';
import { StatusTagConfig } from '@shared/components/filter/components/status-tag/status-tag.component';
import { getSessionStatusTag } from '@shared/components/filter/components/status-tag/statuses/session-status';

type StatusOf = 'match' | 'session';

@Pipe({
  name: 'statusTag',
  standalone: false,
})
export class StatusTagPipe implements PipeTransform {
  transform(value: any, type: StatusOf): StatusTagConfig | undefined {
    switch (type) {
      case 'session':
        return getSessionStatusTag(value);
    }
    return undefined;
  }
}
